<template>
  <div id="ui-kit" class="ui-kit">
    <div class="title-bar">
      <div class="title -heading">UI KIT</div>
      <div class="title">
        <div class="name">Style Guide template</div>
        <div class="for">For Designer and Developer</div>
      </div>
    </div>

    <pre>
      <code class="language-markup">
        <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>kit-box<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
          <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>name<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>Colors<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
          <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>description<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>All colors used in project<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
          <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>component -colors<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>set-box<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>meaning<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
                Positive <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Success <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Approve <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Confirm <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Save <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>color-box<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
                <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>color -green<span class="token punctuation">"</span></span><span class="token punctuation">></span></span><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
                <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>code<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>#56BD5B<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>set-box<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>meaning<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
                Alert <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Warning <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>color-box<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
                <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>color -orange<span class="token punctuation">"</span></span><span class="token punctuation">></span></span><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
                <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>code<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>#F7B422<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>set-box<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>meaning<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
                Negative <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Fail <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Cancel <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Delete <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Danger <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>color-box<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
                <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>color -red<span class="token punctuation">"</span></span><span class="token punctuation">></span></span><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
                <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>code<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>#E34C4C<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>set-box<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>meaning<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
                Active <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Info <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
                Select <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>br</span><span class="token punctuation">/></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>color-box<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>
                <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>color -blue<span class="token punctuation">"</span></span><span class="token punctuation">></span></span><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
                <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>div</span> <span class="token attr-name">class</span><span class="token attr-value"><span class="token punctuation">=</span><span class="token punctuation">"</span>code<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>#00C0EF<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
              <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
            <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
          <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>
        <span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>div</span><span class="token punctuation">></span></span>

      </code>
    </pre>
    <!-- Title Bar End-->
    <div class="kit-box">
      <div class="name">Colors</div>
      <div class="description">All colors used in project</div>
      <div class="component -colors">
        <div class="set-box">
          <div class="meaning">
            Positive <br/>
            Success <br/>
            Approve <br/>
            Confirm <br/>
            Save <br/>
          </div>
          <div class="color-box">
            <div class="color -green"></div>
            <div class="code">#56BD5B</div>
          </div>
        </div>
        <div class="set-box">
          <div class="meaning">
            Alert <br/>
            Warning <br/>
          </div>
          <div class="color-box">
            <div class="color -orange"></div>
            <div class="code">#F7B422</div>
          </div>
        </div>
        <div class="set-box">
          <div class="meaning">
            Negative <br/>
            Fail <br/>
            Cancel <br/>
            Delete <br/>
            Danger <br/>
          </div>
          <div class="color-box">
            <div class="color -red"></div>
            <div class="code">#E34C4C</div>
          </div>
        </div>
        <div class="set-box">
          <div class="meaning">
            Active <br/>
            Info <br/>
            Select <br/>
          </div>
          <div class="color-box">
            <div class="color -blue"></div>
            <div class="code">#00C0EF</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Colors Component -->

    <div class="kit-box">
      <div class="name">Type face</div>
      <div class="description">All typeface used in project</div>
      <div class="component -typeface">
        <div class="set-box">
          <div class="font-name">Prompt</div>
          <div class="example">AaBbCcDd</div>
        </div>
        <div class="set-box">
          <div class="font-name">Prompt</div>
          <div class="example">กขคงจ</div>
        </div>
      </div>
    </div>
    <!-- Type Face Component -->

    <div class="kit-box">
      <div class="name">Typography</div>
      <div class="description">All Information about Heading. Paragraph. etc.</div>
      <div class="component -typography">
        <div class="set-box">
          <div class="detail-box">
            <div class="name">Heading Text</div>
            <div>
              Font-family   : Prompt <br/>
              Style Rec.    : Medium <br/>
              Font-size     : 24 px  <br/>
            </div>
          </div>
          <div class="example -text-xl">
            The standard Lorem Ipsum passage, used since the 1500s <br/>
            ท่อนหนึ่งของ Lorem Ipsum ที่ใช้กันเป็นมาตรฐานมาตั้งแต่ศตวรรษที่ 16 <br/>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name">Large Text</div>
            <div>
              Font-family   : Prompt <br/>
              Style Rec.    : Medium <br/>
              Font-size     : 18 px  <br/>
            </div>
          </div>
          <div class="example -text-lg">
            ตอนที่ 1.10.32 จาก "de Finibus Bonorum et Malorum" เขียนโดย ซิเซโร เมื่อ 45 ปี ก่อนคริตศตวรรษ<br/>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name">Normal Text</div>
            <div>
              Font-family   : Prompt <br/>
              Style Rec.    : Light <br/>
              Font-size     : 16 px  <br/>
            </div>
          </div>
          <div class="example -text-md">
            Lorem Ipsum คือ เนื้อหาจำลองแบบเรียบๆ ที่ใช้กันในธุรกิจงานพิมพ์หรืองานเรียงพิมพ์ <br/>
            มันได้กลายมาเป็นเนื้อหาจำลองมาตรฐานของธุรกิจดังกล่าวมาตั้งแต่ศตวรรษที่ 16 <br/>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name">Small Text</div>
            <div>
              Font-family   : Prompt <br/>
              Style Rec.    : Light <br/>
              Font-size     : 14 px  <br/>
            </div>
          </div>
          <div class="example -text-sm">
            มีหลักฐานที่เป็นข้อเท็จจริงยืนยันมานานแล้ว ว่าเนื้อหาที่อ่านรู้เรื่องนั้นจะไปกวนสมาธิของคนอ่านให้เขวไปจากส่วนที่เป็น Layout
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name">Extra Small Text</div>
            <div>
              Font-family   : Prompt <br/>
              Style Rec.    : Light <br/>
              Font-size     : 12 px  <br/>
            </div>
          </div>
          <div class="example -text-xs">
            ฉบับแปลเมื่อปี ค.ศ. 1914 โดย เอช แร็คแคม
          </div>
        </div>  
      </div>
    </div>
    <!-- Typography Component -->

    <div class="kit-box">
      <div class="name">Button</div>
      <div class="description">All Information about Button.</div>
      <div class="component -button">
        <div class="set-box">
          <div class="detail-box">
            <div class="name">Large Button</div>
            <div>
              Font-size     : 18px <br/>
              Height        : 45px <br/>
              Min-Width     : 110px <br/>
              padding       : 10px 16px <br/>
              Text-Align    : Center <br/>
              Border-Radius : 2px <br/>
              Border        : none <br/>
              Box-Shadow    : 1px 2px 3px rgba (0,0,0,0.3) <br/>
            </div>
          </div>
          <div class="example">
            <div class="button-set">
              <div class="description">Regular (Ex. 70)</div>
              <div class="button-box">
                <button type="button" class="button-lg _bg-green">Buttton</button>
              </div> 
            </div>
            <div class="button-set">
              <div class="description">Hover (Ex. 80)</div>
              <div class="button-box">
                <button type="button" class="button-lg -green-hover">Buttton</button>
              </div> 
            </div>
            <div class="button-set">
              <div class="description">Active (Ex. 80)</div>
              <div class="button-box">
                <button type="button" class="button-lg -green-hover">Buttton</button>
              </div> 
            </div>
            <div class="button-set">
              <div class="description">Disable (Ex. 20)</div>
              <div class="button-box">
                <button type="button" class="button-lg -disable -green-disable">Buttton</button>
              </div> 
            </div>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name">Normal Button</div>
            <div>
              Font-size     : 16px <br/>
              Height        : 35px <br/>
              Min-Width     : 100px <br/>
              padding       : 6px 14px <br/>
              Text-Align    : Center <br/>
              Border-Radius : 2px <br/>
              Border        : none <br/>
              Box-Shadow    : 1px 2px 3px rgba (0,0,0,0.3) <br/>
            </div>
          </div>
          <div class="example">
            <div class="button-set">
              <div class="description">Regular (Ex. 70)</div>
              <div class="button-box">
                <button type="button" class="button-md _bg-green">Buttton</button>
              </div> 
            </div>
            <div class="button-set">
              <div class="description">Hover (Ex. 80)</div>
              <div class="button-box">
                <button type="button" class="button-md -green-hover">Buttton</button>
              </div> 
            </div>
            <div class="button-set">
              <div class="description">Active (Ex. 80)</div>
              <div class="button-box">
                <button type="button" class="button-md -green-hover">Buttton</button>
              </div> 
            </div>
            <div class="button-set">
              <div class="description">Disable (Ex. 20)</div>
              <div class="button-box">
                <button type="button" class="button-md -disable -green-disable">Buttton</button>
              </div> 
            </div>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name">Small Button</div>
            <div>
              Font-size     : 14px <br/>
              Height        : 25px <br/>
              Min-Width     : 90px <br/>
              padding       : 2px 10px <br/>
              Text-Align    : Center <br/>
              Border-Radius : 2px <br/>
              Border        : none <br/>
              Box-Shadow    : 1px 2px 3px rgba (0,0,0,0.3) <br/>
            </div>
          </div>
          <div class="example">
            <div class="button-set">
              <div class="description">Regular (Ex. 70)</div>
              <div class="button-box">
                <button type="button" class="button-sm _bg-green">Buttton</button>
              </div> 
            </div>
            <div class="button-set">
              <div class="description">Hover (Ex. 80)</div>
              <div class="button-box">
                <button type="button" class="button-sm -green-hover">Buttton</button>
              </div> 
            </div>
            <div class="button-set">
              <div class="description">Active (Ex. 80)</div>
              <div class="button-box">
                <button type="button" class="button-sm -green-hover">Buttton</button>
              </div> 
            </div>
            <div class="button-set">
              <div class="description">Disable (Ex. 20)</div>
              <div class="button-box">
                <button type="button" class="button-sm -disable -green-disable">Buttton</button>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Button Component -->

    <div class="kit-box">
      <div class="name">Input Text</div>
      <div class="description">All Information about Input Text.</div>
      <div class="component -input">
        <div class="set-box">
          <div class="detail-box">
            <div class="name">Normal Input</div>
            <div>
              Height        : 35px <br/>
              Min-Width     : 100px <br/>
              padding       : 6px <br/>
              Border-Radius : 2px <br/>
              Label Color   : #B7B7B7 <br/>
              Input Color   : #252525 <br/>
              Border        : 1px solid #B7B7B7 <br/>
            </div>
          </div>
          <div class="example">
            <div class="input-set">
              <div class="input-group">
                <div class="label">Normal Input</div>
                <input class="normal-input" type="text" name="input">
              </div> 
            </div>
            <div class="input-set">
              <div class="input-group">
                <div class="label">Normal Input</div>
                <input class="normal-input" type="text" name="input" value="When you start typing">
              </div> 
            </div>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name"><br/><br/><br/>Icon Input</div>
            <div>
              Icon Color   : #B7B7B7 <br/><br/><br/><br/>
            </div>
          </div>
          <div class="example">
            <div class="input-set">
              <div class="input-group">
                <div class="label">Icon Input</div>
                <input class="icon-input" type="text" name="input">
                <span class="icon fa fa-search" aria-hidden="true"></span>
              </div> 
            </div>
            <div class="input-set">
              <div class="input-group">
                <div class="label">Icon Input</div>
                <input class="icon-input" type="text" name="input" value="When you start typing">
                <i class="icon fa fa-search" aria-hidden="true"></i>
              </div> 
            </div>
          </div>
          <div class="example">
            <div class="input-set">
              <div class="input-group">
                <div class="label">Icon Input</div>
                <input class="icon-input" type="text" name="input">
                <i class="icon fa fa-calendar" aria-hidden="true"></i>
              </div> 
            </div>
            <div class="input-set">
              <div class="input-group">
                <div class="label">Icon Input</div>
                <input class="icon-input" type="text" name="input" value="01/01/2017">
                <i class="icon fa fa-calendar" aria-hidden="true"></i>
              </div> 
            </div>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name"><br/><br/>Input with unit</div>
            <div>
              Unit Color   : #B7B7B7 <br/><br/><br/>
            </div>
          </div>
          <div class="example">
            <div class="input-set">
              <div class="input-group">
                <div class="label">Icon Input</div>
                <input class="unit-input" type="text" name="input">
                <div class="unit">Hour</div>
              </div> 
            </div>
            <div class="input-set">
              <div class="input-group">
                <div class="label">Icon Input</div>
                <input class="unit-input" type="text" name="input" value="3">
                <div class="unit">Hours</div>
              </div> 
            </div>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name"><br/><br/>Active Input</div>
            <div>
              Border Color   : #00C0CF <br/><br/><br/>
            </div>
          </div>
          <div class="example">
            <div class="input-set">
              <div class="input-group">
                <div class="label">Active Input</div>
                <input class="normal-input -active" type="text" name="input">
              </div> 
            </div>
            <div class="input-set">
              <div class="input-group">
                <div class="label">Active Input</div>
                <input class="normal-input -active" type="text" name="input" value="When you start typing">
              </div> 
            </div>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name"><br/><br/>Success Input</div>
            <div>
              Border-Color  : #56BD5B<br/>
            Validator Text  : #56BD5B<br/><br/>
            </div>
          </div>
          <div class="example">
            <div class="input-set">
              <div class="input-group">
                <div class="label">Success Input</div>
                <input class="normal-input" type="text" name="input">
              </div> 
            </div>
            <div class="input-set">
              <div class="input-group">
                <div class="label">Success Input</div>
                <input class="normal-input -success" type="text" name="input" value="When you start typing">
                <div class="validator-text -success">Great! This Username is Available.</div>
              </div> 
            </div>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name"><br/><br/>Success Input</div>
            <div>
              Border-Color  : #E34C4C<br/>
            Validator Text  : #E34C4C<br/><br/>
            </div>
          </div>
          <div class="example">
            <div class="input-set">
              <div class="input-group">
                <div class="label">Error Input</div>
                <input class="normal-input" type="text" name="input">
              </div> 
            </div>
            <div class="input-set">
              <div class="input-group">
                <div class="label">Error Input</div>
                <input class="normal-input -error" type="text" name="input">
                <div class="validator-text -error">This is a required field.</div>
              </div> 
            </div>
          </div>
        </div>
        <div class="set-box">
          <div class="detail-box">
            <div class="name"><br/><br/>Disable Input</div>
            <div>
              Background  : #E1E1E1<br/><br/><br/>
            </div>
          </div>
          <div class="example">
            <div class="input-set">
              <div class="input-group">
                <div class="label">Disable Input</div>
                <input class="normal-input -disable" disabled type="text" name="input">
              </div> 
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Input Component -->

    <div class="kit-box">
      <div class="name">Dropdown</div>
      <div class="description">All Information about Dropdown.</div>
      <div class="component -dropdown">
        <div class="set-box">
          <div class="detail-box">
            <div class="name"><br/><br/>Dropdown</div>
            <div>
              Border Focus        : #00C0Ef <br/><br/><br/>
            </div>
          </div>
          <div class="example">
            <div class="input-set">
              <div class="dropdown-group">
                <div class="label">Normal</div>
                <select class="dropdown">
                  <option value="Menu1">Menu1</option>
                  <option value="Menu2">Menu2</option>
                  <option value="Menu3">Menu3</option>
                </select>
                <i class="fa fa-chevron-down caret" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Dropdown component -->

    <div class="kit-box">
      <div class="name">Tab Select</div>
      <div class="description">All Information about Tab Select.</div>
      <div class="component -tabselect">
        <div class="set-box">
          <div class="detail-box">
            <div class="name"><br/><br/><br/><br/><br/><br/>Tab Select</div>
            <div>
              Border-Top  : 2px <br/>
              Border-color  : #B7B7B7 <br/>
              Unactive Text : #252525<br/><br/><br/><br/><br/><br/><br/><br/>
            </div>
          </div>
          <div class="example">
            <div class="tabselect-set">
            <div class="topic-ex">Tabs Select Example</div>
              <div class="tabselect-group">
                <ul class="nav nav-tabs">
                  <li class="active"><a data-toggle="tab" href="#tab1">TAB 1</a></li>
                  <li><a data-toggle="tab" href="#tab2">TAB 2</a></li>
                  <li><a data-toggle="tab" href="#tab3">TAB 3</a></li>
                  <li><a data-toggle="tab" href="#tab4">TAB 4</a></li>
                </ul>

                <div class="tab-content">
                  <div id="tab1" class="tab-pane fade in active">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed purus sapien, varius nec rutrum quis, fringilla lobortis diam. Suspendisse condimentum dapibus dui id venenatis. Vivamus efficitur ullamcorper tortor a bibendum. In semper lectus tristique commodo gravida. Donec in molestie nisl. Etiam tristique lorem massa, sed pharetra dolor accumsan ac. Aliquam nec sodales diam. Pellentesque vehicula imperdiet lectus eget imperdiet. Nam tristique, tortor non condimentum mattis, ex orci efficitur nulla, ut accumsan justo ante in libero.</p>
                  </div>
                  <div id="tab2" class="tab-pane fade">
                    <p>Phasellus faucibus tortor eu lorem tempus pretium. Nunc nec varius tortor, quis porta urna. Ut quis dapibus nisl. Phasellus porta nibh sed mauris vestibulum viverra. Aenean suscipit libero quam, ac viverra justo blandit non. Maecenas ac nunc a velit consequat interdum vitae nec nisl. Vivamus et arcu ut nisl tincidunt pretium nec id nisi. Proin consectetur volutpat turpis, quis convallis sapien scelerisque nec. Quisque purus velit, ultrices a rutrum ut, gravida a augue. Sed vestibulum consequat ipsum, sed aliquam felis auctor vitae. Pellentesque consectetur sem in dignissim semper. Aliquam a consectetur ex. Duis sollicitudin semper est eget finibus. Donec ultrices diam at pellentesque aliquam. Nullam molestie arcu eros, eget tempus enim pretium in. Donec ut nisi convallis, molestie sem non, interdum est.</p>
                  </div>
                  <div id="tab3" class="tab-pane fade">
                    <p>Donec placerat nulla nec nisl ultrices suscipit. Donec magna nulla, pharetra in egestas at, efficitur ut leo. Morbi volutpat aliquam ipsum sed interdum. Aenean sodales ut ligula quis faucibus. Fusce rutrum rutrum orci, non mollis elit vestibulum nec. Maecenas porta eu sem quis luctus. Mauris sit amet purus interdum, mollis justo at, consectetur enim. Curabitur feugiat erat risus, et eleifend felis posuere aliquet. Vestibulum euismod tellus non dui dignissim tempus.</p>
                  </div>
                  <div id="tab4" class="tab-pane fade">
                    <p>Curabitur quis lorem id odio pharetra varius sit amet quis nunc. Fusce porta ipsum leo, non eleifend tellus pulvinar non. Integer imperdiet tortor elit, vitae sagittis magna fermentum et. </p>
                  </div>
                </div>    
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- TAB SELECT Component -->

    <div class="kit-box">
      <div class="name">Expand Tabs</div>
      <div class="description">All Information about Expand Tabs.</div>
      <div class="component -expandtabs">
        <div class="set-box">
          <div class="detail-box">
            <div class="name"><br/><br/>Expand Tabs</div>
            <div>
              Border-Top    : 2px <br/>
              Border Color  : #B7B7B7 <br/>
              Padding Head  : 14px <br/>
              Padding Body  : 25px <br/>
              Height        : 60px <br/><br/>
            </div>
          </div>
          <div class="example">
            <div class="expandtabs-set">
              <div class="expandtabs-group">
                <div class="panel-group" id="accordion">
                  <div class="panel">
                    <div class="panel-heading" data-toggle="collapse" data-parent="#accordion" href="#collapse1">
                      <div class="panel-title">
                        Collapsible Group 1
                      </div>
                    </div>
                    <div id="collapse1" class="panel-collapse collapse in">
                      <div class="panel-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
                      minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                      commodo consequat.</div>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    

  </div>
</template>

<script>
var Prism = require('prismjs')
var code = `
    <div class="kit-box">
      <div class="name">Colors</div>
      <div class="description">All colors used in project</div>
      <div class="component -colors">
        <div class="set-box">
          <div class="meaning">
            Positive <br/>
            Success <br/>
            Approve <br/>
            Confirm <br/>
            Save <br/>
          </div>
          <div class="color-box">
            <div class="color -green"></div>
            <div class="code">#56BD5B</div>
          </div>
        </div>
        <div class="set-box">
          <div class="meaning">
            Alert <br/>
            Warning <br/>
          </div>
          <div class="color-box">
            <div class="color -orange"></div>
            <div class="code">#F7B422</div>
          </div>
        </div>
        <div class="set-box">
          <div class="meaning">
            Negative <br/>
            Fail <br/>
            Cancel <br/>
            Delete <br/>
            Danger <br/>
          </div>
          <div class="color-box">
            <div class="color -red"></div>
            <div class="code">#E34C4C</div>
          </div>
        </div>
        <div class="set-box">
          <div class="meaning">
            Active <br/>
            Info <br/>
            Select <br/>
          </div>
          <div class="color-box">
            <div class="color -blue"></div>
            <div class="code">#00C0EF</div>
          </div>
        </div>
      </div>
    </div>
`
var html = Prism.highlight(code, Prism.languages.markup)

export default {
  name: 'hcm-standard',
  data () {
    return {
      hello: html
    }
  },
  created () {
    console.log(this.hello)
  }
}
</script>



// WEBPACK FOOTER //
// backup.vue?921798e2